<template>
    <select :disabled="readonly" v-model="displayValue" class="form-control" title="Modelo de Switch">
        <option disabled :value="null">SELECIONE UM MODELO</option>
        <option v-for="sn in rows" :value="sn._id" v-bind:key="sn._id">{{ sn.nome }} - {{ sn.fabricante }}</option>
    </select>
</template>

<script>
import { ModeloSwitch } from "../../class/index";

export default {
    name: "ComboModeloSwitch",
    props: {
        value: {
            default: null
        },
        readonly: {
            default: false
        }
    },
    data() {
        return {
            rows: []
        };
    },
    computed: {
        displayValue: {
            get: function() {
                return this.value;
            },
            set: function(modifiedValue) {
                this.$emit("input", modifiedValue);
            }
        }
    },
    beforeMount() {
        ModeloSwitch
            .all()
            .then(rows => {
                this.rows = rows;
            })
            .catch(err => console.error(err));
    }
};
</script>

<style scoped>
</style>
